import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {NodeVariant} from '../types';

import {nodeAnatomy} from './anatomy';
import minimal from './graph-node-variant-minimal';
import content from './node-content-variant';
import groupedContent from './node-grouped-content-variant';
import {nodeHeadingStyle} from './node-heading-theme';

import {
  $bgColor,
  $borderColor,
  $borderRadius,
  $borderWidth,
  $headingSize,
  $headingWeight,
  $textColor,
} from './css-vars';

const {defineMultiStyleConfig, definePartsStyle} = createMultiStyleConfigHelpers(nodeAnatomy);
const baseStyle = definePartsStyle(({is_grayed_out, style}) => ({
  container: {
    // CSS Vars
    [$borderColor.variable]: style?.borderColor ?? `colors.gray.300`,
    // Layout
    display: `flex`,
    flexDirection: `row`,
    alignItems: `stretch`,
    justifyContent: `center`,
    gap: `8`,
    // Colors
    bgColor: $bgColor.reference,
    opacity: is_grayed_out ? 0.3 : 1,
    // Spacing

    // Borders
    borderRadius: $borderRadius.reference,
    borderStyle: `solid`,
    borderWidth: $borderWidth.reference,
    borderColor: $borderColor.reference,
  },
  body: {
    // CSS Vars
    [$textColor.variable]: `colors.gray.600`,
    [$headingSize.variable]: `fontSizes.xl`,
    [$headingWeight.variable]: `fontWeights.medium`,
    flex: 1,
    // Layout
    px: `12`,
    py: `6`,
    display: `flex`,
    flexDirection: `column`,
    gap: `8`,
    alignItems: `flex-end`,
    justifyContent: `center`,
  },
  heading: nodeHeadingStyle.baseStyle,
  tagline: {
    gap: `2`,
  },
  children: {
    display: `none`,
  },
  footer: {
    display: `none`,
  },
}));

export const GraphNodeTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    [`grouped-content`]: groupedContent,
    content,
    minimal,
  },
  defaultProps: {
    variant: NodeVariant.Minimal,
  },
});
